import React from 'react';
import { motion } from 'framer-motion';
type RevealProps = {
  children: React.ReactNode;
  delay?: number;
  y?: number;
  className?: string;
};
export function Reveal({
  children,
  delay = 0,
  y = 18,
  className
}: RevealProps) {
  return <motion.div className={className} initial={{
    opacity: 0,
    y
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.28,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} data-id="element-54" data-mp="3bi5uq1fhzyfi">
      {children}
    </motion.div>;
}